import React, { useState, useEffect } from 'react';
import { useDebounce } from 'usehooks-ts';

import IbInput, { IIbInputProps } from '../IbInput';

const DEFAULT_DELAY = 500;

export interface IIbDebounceInputProps extends Omit<IIbInputProps, 'value' | 'onChange'> {
  value?: string;
  delay?: number;
  onChange?: (value: string) => void;
  onDebouncedChange?: (value: string) => void;
}

const IbDebounceInput: React.FC<IIbDebounceInputProps> = ({
  value = '',
  delay = DEFAULT_DELAY,
  onChange,
  onDebouncedChange,
  ...otherProps
}) => {
  const [internalValue, setInternalValue] = useState(value);
  const debouncedValue = useDebounce<string>(internalValue, delay);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const onValueChange = (value: string) => {
    setInternalValue(value);
    onChange?.(value);
  };

  useEffect(() => {
    onDebouncedChange?.(debouncedValue);
  }, [debouncedValue]);

  return <IbInput value={internalValue} onChange={onValueChange} {...otherProps} />;
};

export default IbDebounceInput;
